<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">Schooljaren</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title class="pb-0 pt-4 flex-wrap">
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Zoeken"
				single-line
				hide-details
				dense
				class="flex-grow-1 mb-2"
				style="min-width: 200px"
			></v-text-field>
		</v-card-title>

		<v-alert v-if="loadError" type="error" dense outlined class="mx-4 mb-0">
			{{ loadError }}
		</v-alert>

		<v-data-table
			:headers="headers"
			:items="data"
			:search="search"
			:loading="loading"
			class="elevation-0"
		>
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" color="inverted" @click="goNew">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>
						Nieuw schooljaar
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon color="primary" style="cursor: pointer" @click="goEdit(item.id)">
					mdi-pencil
				</v-icon>
			</template>
			<template v-slot:item.active="{ item }">
				<v-chip x-small :color="isOn(item.active) ? 'success' : 'grey'" text-color="white">
					{{ isOn(item.active) ? "Ja" : "Nee" }}
				</v-chip>
			</template>
			<template v-slot:item.active_cursus="{ item }">
				<v-chip x-small :color="isOn(item.active_cursus) ? 'success' : 'grey'" text-color="white">
					{{ isOn(item.active_cursus) ? "Ja" : "Nee" }}
				</v-chip>
			</template>
			<template v-slot:item.active_finance="{ item }">
				<v-chip x-small :color="isOn(item.active_finance) ? 'success' : 'grey'" text-color="white">
					{{ isOn(item.active_finance) ? "Ja" : "Nee" }}
				</v-chip>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../../config";

const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "Schoolyear",
	data() {
		return {
			search: "",
			loading: false,
			loadError: "",
			data: [],
			headers: [
				{ text: "", align: "center", sortable: false, value: "action" },
				{ text: "ID", value: "id" },
				{ text: "Naam", value: "name" },
				{ text: "Actief", value: "active" },
				{ text: "Actief cursus", value: "active_cursus" },
				{ text: "Actief finance", value: "active_finance" }
			]
		};
	},
	created() {
		this.fetchSchoolyears();
	},
	methods: {
		isOn(value) {
			return value != null && Number(value) === 1;
		},
		goNew() {
			this.$router.push({ path: "/schooladmin/schoolyear/new" });
		},
		goEdit(id) {
			this.$router.push({ path: "/schooladmin/schoolyear/update/" + id });
		},
		fetchSchoolyears() {
			var self = this;
			self.loading = true;
			self.loadError = "";
			ax.get("/schoolyear/manage_all")
				.then(function(res) {
					self.data = Array.isArray(res.data) ? res.data : [];
				})
				.catch(function() {
					self.loadError =
						"Schooljaren konden niet worden geladen. Controleer of u bent ingelogd en de API bereikbaar is.";
					self.data = [];
				})
				.finally(function() {
					self.loading = false;
				});
		}
	}
};
</script>
